import React from 'react';
import { styled } from '../../style';

interface OwnProps {
  withPadding?: boolean;
}

function Component({ withPadding, children }: React.PropsWithChildren<OwnProps>) {
  return <Container withPadding={withPadding}>{children}</Container>;
}

export const Disclaimer = React.memo(Component);

const Container = styled.div<OwnProps>`
  position: relative;
  font-size: 14px;
  color: ${(p) => p.theme.colors.primary4};
  ${(p) => p.withPadding && `padding: 10px;`}
`;
